var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        ref: "itemSwiper",
        staticClass: "swiper mySwiper swiper-container item-swiper",
      },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.listEntries, function (slide) {
            return _c(
              "div",
              { staticClass: "swiper-slide item-swiper__slide" },
              [
                _c("div", { staticClass: "item-swiper__slide-left" }, [
                  _c("img", { attrs: { src: slide.img, alt: slide.headline } }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item-swiper__slide-right" }, [
                  _c("div", { staticClass: "item-swiper__txt-wrapper" }, [
                    _c("div", { staticClass: "item-swiper__headline" }, [
                      _vm._v(_vm._s(slide.headline)),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "item-swiper__txt",
                      domProps: { innerHTML: _vm._s(slide.text) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "item-swiper__btn",
                      attrs: { href: slide.realUrl },
                    },
                    [_vm._v(_vm._s(slide.buttonText))]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "swiper-pagination item-swiper__pagination" }),
        _vm._v(" "),
        _c(
          "div",
          { ref: "next", staticClass: "swiper-button-next item-swiper__next" },
          [
            _c("i", {
              staticClass: "fa fa-arrow-right",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "prev", staticClass: "swiper-button-prev item-swiper__prev" },
          [
            _c("i", {
              staticClass: "fa fa-arrow-left",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }